<template>
	<div class="translates">
		<h2>Переводы</h2>
		<btn l='Добавить перевод' i='plus' @press="create()" size="medium"/>
		<hr/>
		<i-list :fields="fields" :data="translates" @input="edit"/>
		<modal title="Перевод +" name="translate-edit" :height="320">
			<div class="body">
				<i-form :data="currentTranslate" :scheme="formScheme" @input="(data)=>{setTranslates(data)}"/>
			</div>
			<modal-control-buttons slot="footer"/>
		</modal>
	</div>
</template>

<script>
export default {
  name: 'translates',
  methods:{
  	edit(tr){
  		this.currentTranslate = tr;
  		console.log(this.currentTranslate);
  		this.$store.commit('modalOpen', "translate-edit");
  	},
  	create(){
  		this.currentTranslate = {};
  		this.$store.commit('modalOpen', "translate-edit");
  	},
  	removeTranslate(){
  		this.$http.delete('content/translates',{body:{code: this.currentTranslate.code}}).then((res)=>{
  			this.$store.commit('removeTranslate', this.currentTranslate.code);
  			this.$store.commit('modalClose', "translate-edit");
  			this.currentTranslate = {};
  		});
  	},
  	setTranslates(trs){
  		if(!trs.code){
  			trs.code = trs.en.replace(/[ ,.#$%^&!@()±]/gim,"_").toLowerCase();
  		}
  		this.$http.post('content/translates',trs).then((res)=>{
  			let {body} =res;
  			if(!body.error){
  				this.$store.commit('addTranslate', body.translate);
  				this.$store.commit('modalClose', "translate-edit");
  			}
  			
  			
  		});
  		//console.log("translates:",);

  	}
  },
  created(){
    let self = this;
    if(!this.$store.state.translates)this.$store.registerModule('translates', {
      state: {
        list:[]
      },
      
      mutations:{
          addTranslate(state, translate){
              state.list.push(translate);
          },
          removeTranslate(state, translateCode){
              state.list = state.reduce((ns,tr)=>{
                  if(tr.code !== translateCode) ns.push(tr);
                  return ns;
              },[]);
          }
      },
      actions:{
          loadTranslates({ commit, state }){
              self.$http.get("content/translates").then((res) => {
                console.log(res.body)
                  state.list = res.body.translates;
              });
          }
      }
    });

    this.$store.dispatch('loadTranslates');
  },
  computed:{
  	translates(){
  		return this.$store.state.translates.list;
  	}
  },
  data () {
    return {
    	currentTranslate:{},
    	formScheme:{
    		"code": {
		        "type": "string",
		        "label": "код",
		        "required":true
		    },
    		"ru": {
		        "type": "string",
		        "label": "Русский",
		        "required":true
		    },
    		"kz": {
		        "type": "string",
		        "label": "Казахский",
		        "required":true
		    },
    		"en": {
		        "type": "string",
		        "label": "Английский",
		        "required":true
		    }
    	},
    	fields:[
    		{label:'Код',name:'code'},
    		{label:'Руский',name:'ru'},
    		{label:'Казахский',name:'kz'},
    		{label:'Английский',name:'en'}
    	]
    }
  }
}
</script>

<style lang="css" scoped>
.translates{
	padding:6px 12px;
}
</style>